"use client";

import { Text } from "@/components/ui/text";
import { ArtDirection } from "@/components/util/art-direction";
import { Video } from "@/components/util/video";

import {
  useDocumentationHeader,
  UseDocumentationHeaderProps,
} from "./use-documentation-header";

export type DocumentationHeaderProps = UseDocumentationHeaderProps;

function DocumentationHeader(props: DocumentationHeaderProps) {
  const {
    styles,
    componentProps,
    sectionName,
    data: { title, description, media },
    isVideoBackground,
  } = useDocumentationHeader(props);

  return (
    <section
      {...componentProps}
      className={styles.base()}
      data-section-name={sectionName}
    >
      <div className={styles.container()}>
        <div className={styles.wrapper()}>
          {isVideoBackground && isVideoBackground && (
            <Video
              className={styles.media()}
              containerClassName={styles.mediaWrapper()}
              src={media?.url || ""}
              mime={media?.mime || ""}
              autoPlay
              muted
              loop
              playsInline
            />
          )}
          {media && !isVideoBackground && (
            <ArtDirection
              className={styles.media()}
              containerClassName={styles.mediaWrapper()}
              desktop={media}
            />
          )}

          <div className={styles.content()}>
            <Text tag="h1" size="displaySmall" className={styles.title()}>
              {title}
            </Text>
            {description && (
              <Text tag="p" size="titleSmall" className={styles.description()}>
                {description}
              </Text>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default DocumentationHeader;
